import { FullPageOverlay } from './FullPageOverlay'

export default FullPageOverlay
